import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { cashService } from '../..//services/cashService';

export const useGetPaymentMethods = () => {
  return useQuery({
    staleTime: 1000 * 60 * 60,
    queryKey: [QUERY_KEYS.cash.payment_methods],
    queryFn: () =>
      cashService.paymentMethods().then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        throw new Error('Fetch failed');
      }),
  });
};
